import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/styleKeyRef.ts
const createInputSchema = z.object({ content: z.string().min(10).max(300) });
const createOutputSchema = z.object({
	id: z.string(),
	refId: z.string()
});
const styleKeyRefContract = oc.prefix("/style-key-ref").tag("StyleKeyRef").router({ create: oc.route({
	summary: "Create a style key ref",
	description: "Saves a style string and returns a short ref ID that can be used in generation parameters.",
	method: "POST",
	path: "/"
}).input(createInputSchema).output(createOutputSchema).errors({ UNAUTHORIZED: {
	status: 401,
	message: "Authentication required"
} }) });
//#endregion
export { styleKeyRefContract };
